// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import ShoppingBag from "@insite/mobius/Icons/ShoppingBag";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import Truck from "@insite/mobius/Icons/Truck";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// import React, { FC, useEffect } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import { Dictionary } from "@insite/client-framework/Common/Types";
import HeaderLink, { HeaderLinkStyles } from "@store/Library/Components/Toolkit/HeaderLink";
import CarFill, { CarFillOffset } from "@store/Library/Components/Toolkit/Icons/Car/CarFill";
import ShoppingBagFill, {
    ShoppingBagFillOffset,
} from "@store/Library/Components/Toolkit/Icons/ShoppingBag/ShoppingBagFill";
import ShoppingCartFill, {
    ShoppingCartFillOffset,
} from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
// import { countBubbleStyles } from "@store/Themes/common/mixins/countBubble"; // Store Custom Code
import { headerHideForDesktopStyles } from "@store/Themes/common/mixins/header";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconMap } from "@toolkit/Framework/Types/Icon";
import React, { FC, useEffect, useMemo } from "react";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { countBubbleStyles } from "@store/Themes/common/mixins/countBubble";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
}

const mapStateToProps = (state: ApplicationState) => ({
    shouldLoadCart: !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading,
    totalCountDisplay: getCurrentCartState(state).value?.totalCountDisplay,
    cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
});

const mapDispatchToProps = {
    loadCurrentCart,
};

export interface CartLinkStyles {
    routerLink?: LinkPresentationProps;
    desktopCountText?: TypographyPresentationProps;
    mobileCountText?: TypographyPresentationProps;
    compactCountText?: TypographyPresentationProps;
    // Starter Custom Code
    headerLink?: HeaderLinkStyles;
}

export const cartLinkStyles: CartLinkStyles = {
    mobileCountText: {
        css: css`
            ${countBubbleStyles(pxToRemArray([-2, null, null, 22]))}; /* Store Custom Code  */

            ${breakpoint("md")} {
                top: ${pxToRem(-5) /* Store Custom Code */};
                /* Store Removed - right */
                /* Store Custom Code - Start */
                left: ${pxToRem(10)};
                font-size: ${pxToRem(7)};
                line-height: ${pxToRem(12)};
                width: ${pxToRem(15)};
                height: ${pxToRem(15)};
                /* Store Custom Code - End */
            }
        `,
    },
};

/* Starter Custom Code - Start */
const iconMap: Dictionary<IconMap | undefined> = {
    cart: {
        src: ShoppingCartFill,
        offset: ShoppingCartFillOffset,
    },
    truck: {
        src: CarFill,
        offset: CarFillOffset,
    },
    bag: {
        src: ShoppingBagFill,
        offset: ShoppingBagFillOffset,
    },
    none: undefined,
};
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: "both" | "label" | "icon";
        [fields.icon]: keyof typeof iconMap;
    };
    isCompactHeaderCart?: boolean;
    theme: BaseTheme;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

/** Reloading the cart makes `totalCountDisplay` temporarily unavailable, so retain the previous value for better UX. */
let retainedTotalCountToDisplay = 0; // Starter Custom Code

const CartLink: FC<Props> = ({
    shouldLoadCart,
    cartUrl,
    totalCountDisplay,
    fields: { visibilityState, icon: selectedIcon },
    loadCurrentCart,
    isCompactHeaderCart,
    theme,
}) => {
    useEffect(() => {
        if (shouldLoadCart) {
            loadCurrentCart({ shouldLoadFullCart: false, replaceCart: false });
        }
    }, [shouldLoadCart]);

    const baseStyles = useMergeStyles("cartLink", cartLinkStyles); // Starter Custom Code

    // Starter Removed - showIcon
    // Starter Removed - showLabel

    if (typeof totalCountDisplay !== "undefined") {
        retainedTotalCountToDisplay = totalCountDisplay;
    }

    const icon = iconMap[selectedIcon || "none"]; // Starter Custom Code

    // Starter Removed - routerLink

    /* Starter Custom Code - Start */
    const showIconOnly = visibilityState === "icon" || isCompactHeaderCart; // Starter Custom Code
    const itemsText = retainedTotalCountToDisplay === 1 ? translate("Item") : translate("Items");

    const styles = useMemo(() => {
        if (showIconOnly) {
            return baseStyles;
        }

        return mergeProps<CartLinkStyles>(baseStyles, {
            mobileCountText: {
                // Store Removed - css
            },
        });
    }, [baseStyles, visibilityState]);
    /* Starter Custom Code - End */

    // Starter Removed - isCompactHeaderCart

    /* Starter Custom Code - Start */
    return (
        <HeaderLink
            href={cartUrl}
            iconSrc={icon?.src}
            iconOffset={icon?.offset}
            showIconOnly={showIconOnly}
            // Store Removed - label
            text={translate("Cart") /* Store Custom Code */}
            extendedStyles={styles.headerLink}
            data-test-selector="cartLink"
        >
            {retainedTotalCountToDisplay ? (
                <Typography {...styles.mobileCountText} /* Store Removed - aria-hidden */>
                    {retainedTotalCountToDisplay}
                    {/* Store Custom Code - Start */}
                    <VisuallyHidden>&nbsp;{itemsText}</VisuallyHidden>
                    {/* Store Custom Code - End */}
                </Typography>
            ) : null}
        </HeaderLink>
    );
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(CartLink)),
    definition: {
        displayName: "Cart",
        icon: "cart-shopping",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Icon and Label", // Starter Custom Code
                        value: "both",
                    },
                    // Starter Removed - Show Label Only
                    {
                        displayName: "Show Icon Only",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "Shopping Cart Icon",
                editorTemplate: "DropDownField",
                options: [
                    // Starter Removed - None
                    {
                        displayName: "Bag",
                        value: "bag",
                    },
                    {
                        displayName: "Cart",
                        value: "cart",
                    },
                    {
                        displayName: "Truck",
                        value: "truck",
                    },
                ],
                defaultValue: "cart",
                fieldType: "General",
                sortOrder: 2,
                isRequired: true, // Starter Custom Code
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
